import { render, staticRenderFns } from "./CarreraPage.vue?vue&type=template&id=7d5dcfa4"
import script from "./CarreraPage.js?vue&type=script&lang=js&external"
export * from "./CarreraPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports